module.exports = __webpack_public_path__ + "img/logo.f6b87528.png";